/**
 * Copyfish — free OCR / screen-text capture and translate
 *
 * A single WAR entry lists nine files explicitly — `dialog.html`, `message-dialog.html`,
 * `config/config.json` and the `images/*` set — matched to <all_urls> with
 * `use_dynamic_url: false`, so each is fetchable from any page at a fixed URL. The
 * `copyfish-32.png` icon is vendor-named and loads through probeImage with no CORS grant.
 *
 * Manifest verified against version 6.3.16.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'eenjdnjldapjajjofmldgmkjaienebbj';

export const copyfish: ExtensionDefinition = {
  id: ID,
  name: 'Copyfish 🐟 Free OCR Software',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 700_000,
  notes:
    'Nine static WAR on <all_urls> with use_dynamic_url:false. The vendor-named ' +
    'copyfish-32.png icon and config/config.json are conclusive.',
  signals: [
    {
      id: 'war-copyfish-icon-32',
      kind: 'web-accessible-resource',
      description:
        'Load images/copyfish-32.png via <img> — a vendor-named icon exposed to <all_urls>; ' +
        'needs no CORS grant, so it works even under a strict page CSP.',
      weight: 1,
      run: () => probeImage(ID, 'images/copyfish-32.png'),
    },
    {
      id: 'war-config-json',
      kind: 'web-accessible-resource',
      description:
        'Fetch config/config.json — the extension config file, a distinctive path ' +
        'independent of the icon.',
      weight: 0.5,
      run: () => probeFetch(ID, 'config/config.json'),
    },
    {
      id: 'war-dialog-html',
      kind: 'web-accessible-resource',
      description: 'Fetch dialog.html — the OCR result dialog, a third static path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'dialog.html'),
    },
  ],
};
